import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';

import styled from 'styled-components';
import PSHeaderHome from './PSHeaderHome';
import PSAsideBar from './PSAsideBar';
import {ModalSuccess} from "./organisms";
import {useDispatch, useSelector} from "react-redux";
import { Redirect } from 'react-router-dom';
import {logout} from "../redux/ducks/user-loginDuck";
import {Routes} from "../../routes";
import {STORAGE_TOKEN_COGNITO} from "../../scripts/Constants";
import {FIELD_NEXTTIME_LOGIN, urlOrg} from "../shared/constants/Constants";

const StyledPSHome = styled.div`

  .top-container{
    width: 100%;
    position: absolute;
    top: 90px;
    z-index: 0;
  }
  .body-container{
    display: grid;
    grid-template-columns: 0.8fr 3fr;
    display: grid;
    margin-bottom: 0 !important;
    width: 100%;
    height: 100%;
    min-height: calc(100vh - 105px );
    background: #ffffff;
    grid-template-columns: 0.8fr 3fr;
    position: relative;
    .column-left {
      background-color: #ffffff;
      border-top-right-radius: 15px;
      border-bottom-right-radius: 15px;
      box-shadow: 3px 6px 18px #0000004D;
    }
    .column-right {
      background: #fff;
      margin-left: 20px;
      padding: 0 1rem;
      .container-children {
        margin: 1rem;
      }
  }

  @media (max-width: 576px) {
    .column-left {
      display: none;
    }
    .column-right {
      width: 100%;
    }
  }
  }
`;

const SECONDS_RELOAD = 14400000;

export default function PSHome({ children }) {
  const user = useSelector((state) => state.user);
  return (
    <StyledPSHome>
      <PSHeaderHome/>
      <div className="top-container">
        {/*<StatusBar message={"Contraseña actualizada con éxito"}/>*/}
      </div>
      <div className="body-container">
        <div className="column-left">
          <PSAsideBar menuSidebar={user.menuSidebarByOrg ? user.menuSidebarByOrg : []}/>
        </div>
        <div className="column-right">
          <div className="container-children">{children}</div>
        </div>
      </div>
    </StyledPSHome>
  );
}

PSHome.propTypes = {};

export const withHome = (Component) => (props) => {
  const [showModal, setShowModal] = useState(false);
  const {idOrg} = useSelector((state) => state.user);
  const url = idOrg ? urlOrg[idOrg].url: '';

  const dispatch = useDispatch();
  const redirectToLogin = () => {
    const urlOrg = url;
    dispatch(logout());
    localStorage.removeItem(STORAGE_TOKEN_COGNITO);
    localStorage.removeItem(FIELD_NEXTTIME_LOGIN);
    localStorage.removeItem(idOrg);
    localStorage.clear();
    return <Redirect to={`${Routes.LOGIN}/${urlOrg}`} />;
  };

  const loadModal = () => {
    const actualDate = new Date();
    const loginDate = localStorage.getItem(FIELD_NEXTTIME_LOGIN) || moment().startOf('day').fromNow();
    if(loginDate){
      const duration = moment.duration(moment(actualDate).diff(loginDate)).asMinutes();
      if( duration >= (60*4)){
        setShowModal(true);
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      loadModal();
    }, SECONDS_RELOAD);

    if(!showModal){
      loadModal();
    }
  });

  return (
    <PSHome>
      {showModal && (
        <ModalSuccess
          className="-"
          title="Tu sesión ha expirado"
          message="Vuelve a iniciar sesión"
          buttonText="Aceptar"
          openModal={showModal}
          onClick={redirectToLogin}
        />
      )}
      <Component {...props} />
    </PSHome>
  );
};
